module.exports = __webpack_public_path__ + "img/meeting_3.4448c155.jpg";